import { render, staticRenderFns } from "./parcelasDescontadas.vue?vue&type=template&id=56ca2371"
import script from "./parcelasDescontadas.vue?vue&type=script&lang=js"
export * from "./parcelasDescontadas.vue?vue&type=script&lang=js"
import style0 from "./parcelasDescontadas.vue?vue&type=style&index=0&id=56ca2371&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports